const store = {
  curIdx: 0,
};
export default store
